import Store from "App/Store.js";

export default (clientSettings, local=false) => {
	Store.dispatch({type: "clientSettings", clientSettings});
	if (local) Store.dispatch({type: "clientSettingsLocal", clientSettings});
};
